export const PageOneInitialValues = (
  farm: IFarmAddInfo | undefined,
  state: IOption | undefined,
  city: IOption | undefined,
) => {
  return {
    title: farm?.title ? farm?.title : '',
    description: farm?.description ? farm?.description : '',
    state: farm?.state ? farm?.state : state ? `${state.value}` : '',
    city: farm?.city ? farm?.city : city ? `${city.value}` : '',
    hide_phone_number: farm?.hide_phone_number
      ? farm?.hide_phone_number
      : false,
  };
};
